import { Grid } from "@radix-ui/themes";

interface RiskCardSkeletonProps {
  count?: number;
}

export function RiskCardSkeleton({ count = 3 }: RiskCardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="relative w-full rounded-lg border border-puntt-neutral-gray-8 bg-base-white p-4 text-start"
          data-testid={`risk-card-skeleton-${index}`}
        >
          {/* Priority Label Skeleton - Top Left */}
          <div className="absolute left-3 top-3">
            <div className="h-6 w-28 animate-pulse rounded-md bg-puntt-neutral-gray-6" />
          </div>

          {/* Risk Content Skeleton */}
          <Grid className="pt-8" gap="2">
            {/* Title Skeleton */}
            <div className="h-6 w-4/5 animate-pulse rounded bg-puntt-neutral-gray-6" />

            {/* Impact Assessment Skeleton */}
            <div className="space-y-2">
              <div className="h-4 w-36 animate-pulse rounded bg-puntt-neutral-gray-6" />
              <div className="h-4 w-full animate-pulse rounded bg-puntt-neutral-gray-6" />
            </div>

            {/* Evidence Label Skeleton */}
            <div className="h-4 w-20 animate-pulse rounded bg-puntt-neutral-gray-6" />

            {/* Evidence Content Skeleton */}
            <div className="rounded-lg border border-puntt-neutral-gray-8 bg-puntt-neutral-gray-2 p-2">
              <div className="h-4 w-full animate-pulse rounded bg-puntt-neutral-gray-6" />
              <div className="mt-1 h-4 w-3/4 animate-pulse rounded bg-puntt-neutral-gray-6" />
            </div>

            {/* Source URL and Button Container Skeleton */}
            <Grid className="mt-4 rounded-lg border bg-base-white p-1">
              <div className="flex items-center justify-between">
                {/* Source URL Skeleton */}
                <div className="h-4 w-64 animate-pulse rounded bg-puntt-neutral-gray-6" />

                {/* Button Skeleton */}
                <div className="h-8 w-36 animate-pulse rounded bg-puntt-neutral-gray-6" />
              </div>
            </Grid>

            {/* Separator Skeleton */}
            <div className="my-2 h-px w-full bg-puntt-neutral-gray-8" />

            {/* Suggested Fix Section Skeleton */}
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <div className="h-4 w-24 animate-pulse rounded bg-puntt-neutral-gray-6" />
                <div className="h-5 w-20 animate-pulse rounded-full bg-puntt-neutral-gray-6" />
              </div>
              <div className="h-4 w-full animate-pulse rounded bg-puntt-neutral-gray-6" />
              <div className="h-4 w-4/5 animate-pulse rounded bg-puntt-neutral-gray-6" />
            </div>

            {/* Owner Information Skeleton */}
            <div className="h-4 w-40 animate-pulse rounded bg-puntt-neutral-gray-6" />
          </Grid>
        </div>
      ))}
    </>
  );
}
